export default {
  methods: {
    makePaymentSuccessMessages (type) {
      if (type === this.paymentTypes.standalone) {
        this.paymentSuccessTitle = this.$t('paymentSuccess.modals.singleBillPaymentSuccessTitle')
        this.paymentSuccessDescription = this.$t('paymentSuccess.modals.singleBillPaymentSuccessDescription', { amount: this.payAmount, name: this.payingCustomer })
      } else if (type === this.paymentTypes.multiple) {
        this.paymentSuccessTitle = this.$t('paymentSuccess.modals.multipleBillsPaymentSuccessTitle')
        this.paymentSuccessDescription = this.$t('paymentSuccess.modals.multipleBillsPaymentSuccessDescription', { amount: this.payAmount })
      } else if (type === this.paymentTypes.total) {
        this.paymentSuccessTitle = this.$t('paymentSuccess.modals.totalBillsPaymentSuccessTitle')
        this.paymentSuccessDescription = this.$t('paymentSuccess.modals.totalBillsPaymentSuccessDescription', { amount: this.payAmount })
      } else if (type === this.paymentTypes.custom) {
        this.paymentSuccessTitle = this.$t('paymentSuccess.modals.customBillPaymentSuccessTitle')
        this.paymentSuccessDescription = this.$t('paymentSuccess.modals.customBillPaymentSuccessDescription', { amount: this.customAmount, name: this.payingCustomer })
      }
    },
    payStandaloneBillWithSavedCard (cardCode) {
      const dataToSend = {
        cardCode: cardCode,
        invoiceNumber: this.paymentInvoiceNumber
      }
      this.paymentLoading = true
      this.$apiRequest.post('user/bills/payment/processpayment/standalone', dataToSend)
        .then(response => {
          if (response.data.status && response.data.status === 'SUCCESS') {
            this.makePaymentSuccessMessages(this.paymentTypes.standalone)
            this.handleClosePaymentModal()
            this.paymentSuccessModalVisible = true
            this.getUnsettledBills()
          } else {
            this.toast('error', {
              message: this.$t('toastMessages.paymentFail')
            })
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payStandaloneBillWithNewCard (options) {
      const dataToSend = {
        invoiceNumber: this.paymentInvoiceNumber,
        saveCard: options.remember
      }
      // get auth form
      this.paymentLoading = true
      this.bankAuthForm = {}
      this.$apiRequest.post('user/bills/payment/standalone', dataToSend)
        .then(response => {
          this.bankAuthForm = response.data
          setTimeout(() => {
            this.$refs.bankForm.submitForm()
          }, 10)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payMultipleBillsWithSavedCard (cardCode, invoiceList = []) {
      const dataToSend = {
        cardCode: cardCode,
        invoiceNumbers: {
          invoiceNumbers: invoiceList
        }
      }
      this.paymentLoading = true
      this.$apiRequest.post('user/bills/payment/processpayment/several', dataToSend)
        .then(response => {
          if (response.data.status && response.data.status === 'SUCCESS') {
            this.makePaymentSuccessMessages(this.paymentTypes.multiple)
            this.handleClosePaymentModal()
            this.paymentSuccessModalVisible = true
            this.getUnsettledBills()
          } else {
            this.toast('error', {
              message: this.$t('toastMessages.paymentFail')
            })
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payMultipleBillsWithNewCard (options, invoiceList = []) {
      const dataToSend = {
        invoiceNumbers: {
          invoiceNumbers: invoiceList
        },
        saveCard: options.remember
      }
      // get auth form
      this.paymentLoading = true
      this.bankAuthForm = {}
      this.$apiRequest.post('user/bills/payment/several', dataToSend)
        .then(response => {
          this.bankAuthForm = response.data
          setTimeout(() => {
            this.$refs.bankForm.submitForm()
          }, 10)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payTotalBillWithSavedCard (cardCode) {
      this.paymentLoading = true
      this.$apiRequest.post(`user/bills/payment/processpayment/all?cardCode=${cardCode}`)
        .then(response => {
          if (response.data.status === 'FAILED') {
            this.toast('error', {
              message: this.$t('toastMessages.paymentFail')
            })
          } else {
            this.makePaymentSuccessMessages(this.paymentTypes.total)
            this.handleClosePaymentModal()
            this.paymentSuccessModalVisible = true
            this.getUnsettledBills()
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payTotalBillWithNewCard (options) {
      // get auth form
      this.paymentLoading = true
      this.bankAuthForm = {}
      this.$apiRequest.post(`user/bills/payment/all?saveCard=${options.remember}`)
        .then(response => {
          this.bankAuthForm = response.data
          setTimeout(() => {
            this.$refs.bankForm.submitForm()
          }, 10)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payCustomBillWithSavedCard (cardCode, amount, customerId) {
      const dataToSend = {
        amount: amount,
        customerId: customerId,
        cardCode: cardCode
      }

      this.paymentLoading = true
      this.$apiRequest.post('user/bills/payment/processpayment/amount', dataToSend)
        .then(response => {
          if (response.data.status === 'FAILED') {
            this.toast('error', {
              message: this.$t('toastMessages.paymentFail')
            })
          } else if (response.data.status === 'SOFT_DECLINE') {
            this.bankAuthForm = response.data.bankFormStartParameters
            setTimeout(() => {
              this.$refs.bankForm.submitForm()
            }, 10)
          } else {
            this.makePaymentSuccessMessages(this.paymentTypes.custom)
            this.handleClosePaymentModal()
            this.paymentSuccessModalVisible = true
            this.getUnsettledBills()
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    },
    payCustomBillWithNewCard (options, amount, customerId) {
      const dataToSend = {
        saveCard: options.remember,
        amount: amount,
        customerId: customerId
      }
      // get auth form
      this.paymentLoading = true
      this.bankAuthForm = {}
      this.$apiRequest.post('user/bills/payment/amount', dataToSend)
        .then(response => {
          this.bankAuthForm = response.data
          setTimeout(() => {
            this.$refs.bankForm.submitForm()
          }, 10)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.paymentLoading = false
        })
    }
  }
}
